module.exports = __webpack_public_path__ + "static/img/wechat.7d2c764.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wechat.jpg
// module id = bzqt
// module chunks = 1